import React from "react";

export const TogglerContext = React.createContext({});
export const SettingsContext = React.createContext({});
export const CategoryContext = React.createContext({});
